<template>
  <section class="team_member_area section_padding text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="hero-section-title text-center">
            <h1>Meet The Team</h1>
          </div><!--end .hero-section-title-->
        </div><!--end .col-md-12-->

        <div class="col-md-3 col-sm-6">
          <div class="team_member">
            <img src="/assets/images/team/team-1.jpg" alt="team 1">
            <div class="team_details">
              <h3>Rose Ford <span class="skills">- Manager</span></h3>
              <ul class="team_socials">
                <li><a href=""><i class="fa fa-twitter"></i></a></li>
                <li><a href=""><i class="fa fa-facebook"></i></a></li>
                <li><a href=""><i class="fa fa-youtube-play"></i></a></li>
              </ul>
            </div><!--end .team_details-->
          </div><!--end .team_member-->
        </div><!--end .col-md-3-->
        <div class="col-md-3 col-sm-6">
          <div class="team_member">
            <img src="/assets/images/team/team-2.jpg" alt="team 2">
            <div class="team_details">
              <h3>Mike Olsen <span class="skills">- Worker</span></h3>
              <ul class="team_socials">
                <li><a href=""><i class="fa fa-twitter"></i></a></li>
                <li><a href=""><i class="fa fa-facebook"></i></a></li>
                <li><a href=""><i class="fa fa-youtube-play"></i></a></li>
              </ul>
            </div><!--end .team_details-->
          </div><!--end .team_member-->
        </div><!--end .col-md-3-->
        <div class="col-md-3 col-sm-6">
          <div class="team_member">
            <img src="/assets/images/team/team-3.jpg" alt="team 3">
            <div class="team_details">
              <h3>Emmyson <span class="skills">- Founder</span></h3>
              <ul class="team_socials">
                <li><a href=""><i class="fa fa-twitter"></i></a></li>
                <li><a href=""><i class="fa fa-facebook"></i></a></li>
                <li><a href=""><i class="fa fa-youtube-play"></i></a></li>
              </ul>
            </div><!--end .team_details-->
          </div><!--end .team_member-->
        </div><!--end .col-md-3-->
        <div class="col-md-3 col-sm-6">
          <div class="team_member">
            <img src="/assets/images/team/team-4.jpg" alt="team 4">
            <div class="team_details">
              <h3>John Smith <span class="skills">- Worker</span></h3>
              <ul class="team_socials">
                <li><a href=""><i class="fa fa-twitter"></i></a></li>
                <li><a href=""><i class="fa fa-facebook"></i></a></li>
                <li><a href=""><i class="fa fa-youtube-play"></i></a></li>
              </ul>
            </div><!--end .team_details-->
          </div><!--end .team_member-->
        </div><!--end .col-md-3-->
      </div><!--end .row-->
    </div><!--end .container-->
  </section>
</template>

<script>
    export default {
      name: "Team"
    }
</script>

<style scoped>

</style>
